import { Component, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as enums from '../../enums/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'
import * as util from '../../util/index'

import { BaseRequestComponent }                from '../../baseclasses/BaseRequest.component';

//constants
import { Constants }         from '../../constants/Constants';

//components
import {UserInfoComponent} from '../../components/ControlGroups/UserInfo.component';
import {CompletionDetailsComponent} from '../../components/ControlGroups/CompletionDetails.component';
import {GeneralDetailsComponent} from '../../components/ControlGroups/GeneralDetails.component';
import {SalesAndDeliveryDetailsComponent} from '../../components/ControlGroups/SalesAndDeliveryDetails.component';
import {NotesComponent} from '../../components/ControlGroups/Notes.component';
import {RequestHeaderComponent} from '../../components/Controls/RequestHeader.component';
import {ChangePhoneNumberDialogComponent} from '../../components/Employees/ChangePhoneNumberDialog.component';

@Component({
  selector: 'my-createvisitplanupdate-request',
  templateUrl: './CreateVisitPlanUpdateRequest.component.html'
})
export class CreateVisitPlanUpdateRequestComponent extends BaseRequestComponent {

    userInfo: ent.UserInfo;
    requestToSave: ent.Request;
    requestTypeID: number = enums.RequestTypeEnum.VisitPlanUpdate;
    
    @ViewChild(UserInfoComponent) userInfoComponent: UserInfoComponent;
    @ViewChild(CompletionDetailsComponent) completionDetailsComponent: CompletionDetailsComponent;
    @ViewChild(GeneralDetailsComponent) generalDetailsComponent: GeneralDetailsComponent;
    @ViewChild(SalesAndDeliveryDetailsComponent) salesAndDeliveryComponent: SalesAndDeliveryDetailsComponent;
    @ViewChild(ChangePhoneNumberDialogComponent) changePhoneNumberDialogComponent: ChangePhoneNumberDialogComponent;
    @ViewChild(NotesComponent) notesComponent: NotesComponent;

    constructor() 
    {
        super();
    }


    ngOnInit(): void {
        if (!this.authenticationService.checkLoginStatus())
        {
              this.router.navigate(['login']);
        }

        this.userInfo = this.authenticationService.getUserInfo();
        this.userInfoComponent.onSalesOfficeChange.subscribe((x: any) => this.userInfoSalesOfficeChange(x));
    }

    ngAfterViewInit() {
        super.ngAfterViewInit();
    }

    onSaveClick(event: any){
        
        this.requestToSave = {
            ID: this.requestID,
            RequestTypeID: enums.RequestTypeEnum.VisitPlanUpdate,
            RequestStatusID: this.request ? this.request.RequestStatusID : enums.RequestStatusEnum.Open,
            GeneralInfo: this.generalDetailsComponent.generalInfo,
            SalesAndDeliveryInfo: this.salesAndDeliveryComponent.salesAndDeliveryInfo,
            EmployeeID: this.userInfoComponent.userInfo.Employee.ID, 
            SalesOfficeID: this.userInfoComponent.userInfo.SalesOffice.ID, 
            OtherInfo: this.notesComponent.otherInfo,
            PhoneNumber: this.userInfoComponent.userInfo.Employee.PhoneNumber,
            RequestDate: new Date()
        };

        util.RequestUtil.LoadCompletionDetails(this.requestToSave, this.completionDetailsComponent);

        this.requestToSave.SalesAndDeliveryInfo.GoodsReceivingHoursStartString = this.salesAndDeliveryComponent.getStartTime();
        this.requestToSave.SalesAndDeliveryInfo.GoodsReceivingHoursEndString = this.salesAndDeliveryComponent.getEndTime();
        
        if (this.userInfoComponent.request.PhoneNumber){
            this.requestToSave.PhoneNumber = this.userInfoComponent.request.PhoneNumber;
        }

        this.requestToSave.RequestDays = util.RequestUtil.LoadRequestDays(this.requestToSave, this.salesAndDeliveryComponent.deliveryDaysDayOfWeekMultiSelectComponent, enums.DayType.Delivery);
        this.requestToSave.RequestDays = util.RequestUtil.LoadRequestDays(this.requestToSave, this.salesAndDeliveryComponent.callDaysDayOfWeekMultiSelectComponent, enums.DayType.Call);

        this.requestToSave.Addresses = [];

        this.changePhoneNumberDialogComponent.promptToUpdatePassword(this.requestToSave.PhoneNumber, this.userInfoComponent.userInfo.Employee.PhoneNumber, this.userInfoComponent.userInfo.Employee.ID);

    }

    onCustomerTypeChanged(value: number){
        this.salesAndDeliveryComponent.setCustomerType(value);
    }

    userInfoSalesOfficeChange(salesOffice: ent.SalesOffice){
        
        this.salesAndDeliveryComponent.setSalesOffice(salesOffice, null);
    }
    onYes(event: ent.Response){
        this.requestHeaderComponent.handleResponse(event);
        this.saveRequest(this.requestToSave);
    }

    onNo(event: any){
        this.saveRequest(this.requestToSave);
    }

    onCancel(event: any){
        //do nothing
    }


}